var map = {
	"./template.bet575": 1872,
	"./template.bet575.tsx": 1872,
	"./template.bet777": 1873,
	"./template.bet777.tsx": 1873,
	"./template.betgalaxy": 1874,
	"./template.betgalaxy.tsx": 1874,
	"./template.betprofessor": 2054,
	"./template.betprofessor.tsx": 2054,
	"./template.betroyale": 1875,
	"./template.betroyale.tsx": 1875,
	"./template.betstride": 1876,
	"./template.betstride.tsx": 1876,
	"./template.buffalobet": 1877,
	"./template.buffalobet.tsx": 1877,
	"./template.chromabet": 1878,
	"./template.chromabet.tsx": 1878,
	"./template.default": 709,
	"./template.default.tsx": 709,
	"./template.epicodds": 1879,
	"./template.epicodds.tsx": 1879,
	"./template.fiestabet": 2008,
	"./template.fiestabet.tsx": 2008,
	"./template.gigabet": 1880,
	"./template.gigabet.tsx": 1880,
	"./template.goldenbet888": 1881,
	"./template.goldenbet888.tsx": 1881,
	"./template.goldenrush": 1882,
	"./template.goldenrush.tsx": 1882,
	"./template.hyperbet": 1883,
	"./template.hyperbet.tsx": 1883,
	"./template.juicybet": 2009,
	"./template.juicybet.tsx": 2009,
	"./template.junglebet": 2010,
	"./template.junglebet.tsx": 2010,
	"./template.magnumbet": 1884,
	"./template.magnumbet.tsx": 1884,
	"./template.oldgill": 1885,
	"./template.oldgill.tsx": 1885,
	"./template.puntcity": 1886,
	"./template.puntcity.tsx": 1886,
	"./template.puntgenie": 1887,
	"./template.puntgenie.tsx": 1887,
	"./template.pyramidbet": 1888,
	"./template.pyramidbet.tsx": 1888,
	"./template.questbet": 1889,
	"./template.questbet.tsx": 1889,
	"./template.slambet": 1890,
	"./template.slambet.tsx": 1890,
	"./template.sterlingparker": 1891,
	"./template.sterlingparker.tsx": 1891,
	"./template.sugarcastle": 2055,
	"./template.sugarcastle.tsx": 2055,
	"./template.templebet": 1892,
	"./template.templebet.tsx": 1892,
	"./template.titanbet": 1893,
	"./template.titanbet.tsx": 1893,
	"./template.ts": 998,
	"./template.vikingbet": 1894,
	"./template.vikingbet.tsx": 1894,
	"./template.volcanobet": 1895,
	"./template.volcanobet.tsx": 1895,
	"./template.wellbet": 1896,
	"./template.wellbet.tsx": 1896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2793;